import { OcpsPolicy, isOcpsPolicyEnabled } from 'owa-ocps-policy-store';
import { isPrivacyRoamingEnabled } from './isPrivacyRoamingEnabled';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';

export const getOptionalExperiencesPolicy = (): boolean =>
    isPrivacyRoamingEnabled()
        ? isOcpsPolicyEnabled(
              OcpsPolicy.OptionalConnectedExperiences,
              true /* enabledIfUndefined */,
              getGlobalSettingsAccountMailboxInfo()
          )
        : true;
